import { CustomFieldDefinitionModels, CustomFieldDefinitionTypes } from '@nx-smartmonkey/shared/domain';

export const ModelToIntlId: { [key in CustomFieldDefinitionModels | `all`]: string } = {
  all: `projects.settings.fields.category.all`,
  task: `projects.settings.fields.category.task`,
  client: `projects.settings.fields.category.client`,
  vehicle: `projects.settings.fields.category.vehicle`,
  service_report_completed: `projects.settings.fields.category.service_report_completed`,
  service_report_canceled: `projects.settings.fields.category.service_report_canceled`,
  service_report_task_completed: `projects.settings.fields.category.service_report_task_completed`,
  service_report_task_canceled: `projects.settings.fields.category.service_report_task_canceled`,
};

export const TypeToIntlId: { [key in CustomFieldDefinitionTypes | `categorical_multiple`]: string } = {
  boolean: `projects.settings.fields.custom_fields.types.boolean`,
  text: `projects.settings.fields.custom_fields.types.text`,
  categorical: `projects.settings.fields.custom_fields.types.categorical`,
  categorical_multiple: `projects.settings.fields.custom_fields.types.categorical_multiple`,
  numerical: `projects.settings.fields.custom_fields.types.numerical`,
};
